module.exports = __webpack_public_path__ + "static/og-50f471a4e2232a63b9f10e57e1a719f5.png";